import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';

type PageWrapperTypeMap = BaseTypeMap<'main'>;

export type PageWrapperProps = ComponentProps<PageWrapperTypeMap>;

export const pageWrapperGrid = cx(
  'grid',
  'grid-cols-[minmax(1em,_1fr)_minmax(0,_44em)_minmax(1em,_1fr)]',
  'sm:grid-cols-[minmax(2em,_1fr)_minmax(0,_67.5em)_minmax(2em,_1fr)]',
  'md:grid-cols-[minmax(2em,_1fr)_minmax(0,_81em)_minmax(2em,_1fr)]'
);

export const halfPageWrapperGrid = cx(
  'grid',
  'grid-cols-[minmax(1em,_1fr)_minmax(0,_22em)_minmax(1em,_1fr)]',
  'sm:grid-cols-[minmax(2em,_1fr)_minmax(0,_33.75em)_minmax(2em,_1fr)]',
  'md:grid-cols-[minmax(2em,_1fr)_minmax(0,_40.5em)_minmax(2em,_1fr)]'
);

export const leftHalfWrapper = cx(
  'grid',
  'grid-cols-[minmax(1em,_1fr)_minmax(0,_22em)]',
  'sm:grid-cols-[minmax(2em,_1fr)_minmax(0,_33.75em)]',
  'md:grid-cols-[minmax(2em,_1fr)_minmax(0,_40.5em)]'
);

export const rightHalfWrapper = cx(
  'grid',
  'grid-cols-[minmax(0,_22em)_minmax(1em,_1fr)]',
  'sm:grid-cols-[minmax(0,_33.75em)_minmax(2em,_1fr)]',
  'md:grid-cols-[minmax(0,_40.5em)_minmax(2em,_1fr)]'
);

export const PageWrapper: Component<PageWrapperTypeMap> = forwardRef(
  function PageWrapper({ children, className, ...rest }, ref) {
    return (
      <Box
        as="main"
        className={cx(pageWrapperGrid, className)}
        ref={ref}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);
